import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useGoogleMapsModule } from '../external-module.js';

var InfoWindow = (_param)=>{
    var { options: optionsProp  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "options"
    ]);
    const [ReactGoogleMaps] = useGoogleMapsModule();
    if (!ReactGoogleMaps) {
        return null;
    }
    const options = swcHelpers.objectSpread({}, optionsProp, {
        pixelOffset: undefined
    });
    if (optionsProp === null || optionsProp === void 0 ? void 0 : optionsProp.pixelOffset) {
        options.pixelOffset = swcHelpers.objectSpread({}, optionsProp.pixelOffset, {
            equals: optionsProp.pixelOffset.equals ? optionsProp.pixelOffset.equals : ()=>false
        });
    }
    return /*#__PURE__*/ React__default.createElement(ReactGoogleMaps.InfoWindow, swcHelpers.extends({
        options: options
    }, props));
};

export { InfoWindow };
//# sourceMappingURL=InfoWindow.js.map
